export const ENDPOINTS = {
  // Team endpoints
  TEAMS: {
    GET_TEAM_ROSTER_PLAYERS: (teamId, rosterId) =>
      `/teams/${teamId}/rosters/${rosterId}/players`,
    UPDATE_ROSTER_JERSEY_COLORS: (teamId, rosterId) =>
      `/teams/${teamId}/rosters/${rosterId}/jersey-colors`,
  },
  // Game endpoints
  GAMES: {
    GET_GAME_ROSTERS: (gameId) => `/games/${gameId}/rosters`,
    GET_GAME_TIMELINE: (gameId) => `/games/${gameId}/timeline`,
    GET_GAME_SCOREBOARD: (gameId) => `/games/${gameId}/scoreboard`,
    UPDATE_GAME_ROSTER_JERSEY: (gameId, gamePlayerRosterId) =>
      `/games/${gameId}/rosters/${gamePlayerRosterId}/jersey-color`,
    DELETE_GENERIC_GOAL: (gameId) => `/games/${gameId}/goals`,
    GET_GAME_SETTINGS: (gameId) => `/games/${gameId}/settings`,
    GET_GAME_SHOOTOUT: (gameId) => `/games/${gameId}/shootout`,
  },
  // Player endpoints
  PLAYERS: {
    GET_PLAYER: (playerId) => `/players/${playerId}`,
    UPDATE_PLAYER: (playerId) => `/players/${playerId}`,
    GET_PLAYER_HIGHLIGHTS: (playerId) => `/players/${playerId}/highlights`,
    GET_PLAYER_PROFILE_STATS: (playerId) =>
      `/players/${playerId}/stats/profile/list/v2`,
    GET_PLAYER_FAMILY: (playerId) => `/users/me/players/${playerId}/family`,
    INVITE_PLAYER_FAMILY: (playerId) =>
      `/users/me/players/${playerId}/family/invite`,
    UPDATE_PLAYER_FAMILY_CONTACT: (playerId, contactId) =>
      `/users/me/players/${playerId}/family/${contactId}`,
    DELETE_PLAYER_FAMILY_CONTACT: (playerId, contactId) =>
      `/users/me/players/${playerId}/family/${contactId}`,
    // Invitation id IS the family contactId. The base URL already ends in
    // /v1, so this path must NOT repeat it.
    RESEND_PLAYER_FAMILY_INVITE: (contactId) =>
      `/invitations/${contactId}/resend`,
    // Self-scoped routes used ONLY by the new Edit Player profile modal
    // (web + mobile). The plain /players/:id routes above stay as-is — other
    // callers still read the `teams` object from that response.
    GET_ME_PLAYER: (playerId) => `/users/me/players/${playerId}`,
    UPDATE_ME_PLAYER: (playerId) => `/users/me/players/${playerId}`,
    UPLOAD_ME_PLAYER_IMAGE: (playerId) => `/users/me/players/${playerId}/image`,
    DELETE_ME_PLAYER_IMAGE: (playerId) => `/users/me/players/${playerId}/image`,
  },
  // Search endpoints
  SEARCH: {
    ADMIN_PLAYERS: () => '/search/admin/players',
  },
  // Highlight endpoints
  HIGHLIGHTS: {
    GET_HIGHLIGHT: (highlightId) => `/highlights/${highlightId}`,
  },
  // User endpoints
  USERS: {
    GET_ME2: () => '/users/me2',
    GET_MY_REGISTRATIONS: () => '/users/me/registrations',
    GET_MY_PENDING_INSTALLMENTS: () => '/users/me/installments/pending',
    GET_MY_PENDING_DEPOSITS: () => '/users/me/deposits/pending',
    GET_MY_BILLING: (billingId) => `/users/me/billing/${billingId}`,
    GET_ME_PLAYERS3: () => '/users/me/players3',
    GET_ME_FAMILY: () => '/users/me/family',
    GET_MY_SUSPENSIONS: () => '/users/me/suspensions',
  },
}
